import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Jobs from "@/pages/Jobs";
import Employees from "@/pages/Employees";
import Salaries from "@/pages/Salaries";
import Supplies from "@/pages/Supplies";
import ShopExpenses from "@/pages/ShopExpenses";
import Finans from "@/pages/Finans";
import Appointments from "@/pages/Appointments";
import Periods from "@/pages/Periods";
import Parts from "@/pages/Parts";
import Packages from "@/pages/Packages";
import Quotes from "@/pages/Quotes";
import QuotePrint from "@/pages/QuotePrint";
import JobPrint from "@/pages/JobPrint";
import Insurance from "@/pages/Insurance";
import MonthlyReportPrint from "@/pages/MonthlyReportPrint";
import TrackJob from "@/pages/TrackJob";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/track/:token" element={<TrackJob />} />
            <Route
              path="/print/quote/:id"
              element={
                <ProtectedRoute>
                  <QuotePrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/print/job/:id"
              element={
                <ProtectedRoute>
                  <JobPrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/print/monthly-report"
              element={
                <ProtectedRoute>
                  <MonthlyReportPrint />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="periods" element={<Periods />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="insurance" element={<Insurance />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="parts" element={<Parts />} />
              <Route path="packages" element={<Packages />} />
              <Route path="employees" element={<Employees />} />
              <Route path="salaries" element={<Salaries />} />
              <Route path="supplies" element={<Supplies />} />
              <Route path="shop-expenses" element={<ShopExpenses />} />
              <Route path="finans" element={<Finans />} />
              <Route path="appointments" element={<Appointments />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
